import moment from "moment";
import { useTranslation } from "react-i18next";
import { TableCell } from "../../../components/table/table-cell/table-cell";
import InfinityTable from "../../../components/infinity-table/infinity-table";

const inputTypes = {
  'message:single': 'Single choice',
  'message:multi': 'Multiple choice',
  'message:input': 'Text input',
  'message:picker': 'Picker',
  'message:slider': 'Slider',
  'message:date': 'Date',
  'message:time': 'Time'
};

const ProfileTable = ({
  data,
  sort,
  onTableChange,
  onHandleRowClick,
  selectionColumn,
  containerRef,
  after,
}) => {
  const { t } = useTranslation();

  const columns = [
    {
      title: t("subject_management.profile.table.title"),
      dataIndex: "title",
      key: "title",
      width: "30%",
      sorter: true,
      sortOrder:
        sort?.field === "title"
          ? (sort?.order === "ASC" ? "ascend" : "descend")
          : null,
      render: (_, profile) => <TableCell title={profile.title} />,
    },
    {
      title: t("subject_management.profile.table.status"),
      dataIndex: "status",
      key: "status",
      width: "20%",
      sorter: true,
      sortOrder:
        sort?.field === "status"
          ? (sort?.order === "ASC" ? "ascend" : "descend")
          : null,
      render: (_, profile) => (
        <TableCell text={profile.boundTo && profile.boundTo.length > 0 ? 'Mapped' : 'Not mapped'} />
      ),
    },
    {
      title: t("subject_management.profile.table.input_type"),
      dataIndex: "inputType",
      key: "inputType",
      width: "20%",
      sorter: true,
      sortOrder:
        sort?.field === "inputType"
          ? (sort?.order === "ASC" ? "ascend" : "descend")
          : null,
      render: (_, profile) => <TableCell text={inputTypes[profile.inputType]} />,
    },
    {
      title: t("subject_management.profile.table.last_modified"),
      dataIndex: "updatedAt",
      key: "updatedAt",
      width: "30%",
      sorter: true,
      sortOrder:
        sort?.field === "updatedAt"
          ? (sort?.order === "ASC" ? "ascend" : "descend")
          : null,
      render: (_, profile) => (
        <TableCell
          text={`${moment(profile.updatedAt).utc().format("DD MMM YYYY, HH:mm")}, UTC` || "N/A"}
        />
      ),
    },
  ];

  const tableColumns = selectionColumn ? [selectionColumn, ...columns] : columns;

  return (
    <InfinityTable
      data={data}
      tableColumns={tableColumns}
      containerRef={containerRef}
      after={after}
      isLoading={false}
      hasMore={false}
      onHandleRowClick={onHandleRowClick}
      onChange={onTableChange} // важливо — піднімаємо sorter нагору
    />
  );
};

export default ProfileTable;